import { useCall } from "@/hooks/useCall/useCall";
import { useHasLineWithLanguages } from "@/hooks/useHasLineWithLanguages/useHasLineWithLanguages";

import { FEATURE_NAME } from "@/components/LicenseGuard/LicenseGuard.constant";
import { useHasLicenseAccess } from "@/components/LicenseGuard/useHasLicenseAccess";
import { useCcAccess } from "../useCcAccess/useCcAccess";

export const useShouldDisplayPromotionalBanner = () => {
  const { call } = useCall();

  const { hasLine } = useHasLineWithLanguages({
    languages: ["en-*", "fr-*", "es-*", "it-*", "nl-*", "de-*"],
  });
  const { canRead } = useCcAccess();
  const hasAiStandardAccess = useHasLicenseAccess({
    feature: FEATURE_NAME.AI_STANDARD_ACCESS,
  });

  return [
    canRead,
    hasLine,
    !hasAiStandardAccess,
    Boolean(call?.transcription),
  ].every(Boolean);
};
